const IGNORE_ERRORS_LIST = [
  // Network errors such as going offline or being blocked by a proxy
  /.*Failed to fetch.*/g,
  /.*Network Error.*/g,
  /.*Load failed.*/g,
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  /.*e.extra.agent.*/g,
  /.*timeout of 10000ms exceeded.*/g,
  /.*undefined is not an object (evaluating 't.default').*/g,
  /.*Cannot find module.*/g,
  /.*OneTrust: Invalid domain id.*/g,
  /.*CSS_CHUNK_LOAD_FAILED.*/g,
  /.*Required token is missing.*/g,
  /.*Token Required.*/g,
  /.*Loading chunk.*/g,
  /.*Loading CSS chunk.*/g,
  /.*code 409.*/g,
  /.*code 400.*/g,
  /.*Suspected Fraud.*/g,
  /.*Failed to execute 'insertBefore'.*/g,
  // solidSdk: PayPal button error (close payPal popup)
  /.*isTrusted.*/g,
  /.*undefined is not an object (evaluating 'r.DomainData').*/g,
  /.*null is not an object (evaluating 'this.selector.appendChild').*/g,
  /.*The object can not be found here.*/g,
  /.*undefined is not an object (evaluating 'e.Domain').*/g,
  /.*The object can not be cloned.*/g,
  /.*window.Zeit.setFontSize.*/g,
  /.*Can't find variable: iom.*/g,
  /.*InvalidSignatureException.*/g,
  /.*totalRetryDelay.*/g,
  /.*Can't find variable: stopYouTubeVideos.*/g,
  /.*Window closed for postrobot_method before ack.*/g,
  /.*Can't find variable: clickPauseText2SpeechButton.*/g,
  /.*Right side of assignment cannot be destructured.*/g,
  /.*Data Collector must be created with Kount and\/or PayPal.*/g,
  /.*Can't find variable: PaymentAutofillConfig.*/g,
  /.*null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect').*/g,
  /.*undefined is not an object (evaluating 't.Domain')*/g,
  /.*undefined is not an object (evaluating 'n.length')*/g
];

const IGNORE_URLS_LIST = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i,
  // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
];

const BLACK_LIST_HANDLED_ERROR_NAMES = [
  "InvalidSignatureException",
  "totalRetryDelay",
  "timeout of 10000ms exceeded",
  "Can't find variable: iom",
  "Can't find variable: stopYouTubeVideos",
  "Window closed for postrobot_method before ack",
  "Can't find variable: clickPauseText2SpeechButton",
  "Right side of assignment cannot be destructured",
  "The object can not be cloned.",
  "undefined is not an object (evaluating 't.default')",
  "Data Collector must be created with Kount and/or PayPal.",
  "Can't find variable: PaymentAutofillConfig",
  "null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect')",
  "undefined is not an object (evaluating 't.Domain')",
  "undefined is not an object (evaluating 'n.length')"
];

const SENTRY_PAYMENT = "PAYMENTS";
const SENTRY_TESTANIA = "TESTANIA";
const SENTRY_ANALYTIC = "ANALYTIC";
const SENTRY_AXIOS = "APP_AXIOS";
const SENTRY_APP = "APP";
const SENTRY_ONE_TRUST = "ONE_TRUST";
const SENTRY_CABINET = "CABINET";
const SENTRY_FACEBOOK = "FACEBOOK";
const SENTRY_AXIOS_URGENT = "APP_AXIOS_URGENT";
const SENTRY_LABEL_LIST = [
  SENTRY_FACEBOOK,
  SENTRY_PAYMENT,
  SENTRY_TESTANIA,
  SENTRY_ANALYTIC,
  SENTRY_AXIOS,
  SENTRY_AXIOS_URGENT,
  SENTRY_APP,
  SENTRY_ONE_TRUST,
  SENTRY_CABINET
];

const CRITICAL = "fatal";
const ERROR = "error";
const WARNING = "warning";
const ERROR_LEVELS = {
  CRITICAL,
  ERROR,
  WARNING
};

const IOS = "iOS";
const ANDROID = "Android";
const CHROME = "Chrome";
const IOS_MIN_VERSION = 14.3;
const ANDROID_MIN_VERSION = 7;
const CHROME_MIN_VERSION = 59;

export { ANDROID, ANDROID_MIN_VERSION, BLACK_LIST_HANDLED_ERROR_NAMES, CHROME, CHROME_MIN_VERSION, CRITICAL, ERROR, ERROR_LEVELS, IGNORE_ERRORS_LIST, IGNORE_URLS_LIST, IOS, IOS_MIN_VERSION, SENTRY_ANALYTIC, SENTRY_APP, SENTRY_AXIOS, SENTRY_AXIOS_URGENT, SENTRY_CABINET, SENTRY_FACEBOOK, SENTRY_LABEL_LIST, SENTRY_ONE_TRUST, SENTRY_PAYMENT, SENTRY_TESTANIA, WARNING };
//# sourceMappingURL=bundle.js.map
